import { useLocation } from 'react-router-dom'
import NavLink from '../navLink'

const Subpages = ({ children, name = '', className = null, hidden = '', title2 = '' }) => {
  const { pathname } = useLocation()
  const isZixunsulan = pathname.includes('zixunsulan')

  return (
    <div className={`max-w-1200 mx-auto pt-10 ${className}`}>
      {!isZixunsulan && (
        <div>
          当前位置：<NavLink to="/">首页</NavLink> {'>>'} <span>{name}</span>
        </div>
      )}
      <h1
        className={`${hidden} text-center mt-11 text-[#0189D5] font-alhpr font-bold text-[30px] mb-10 lg:mb-[68px]`}
      >
        {name}
        {title2 ? <p className="text-[16px] text-black mt-2">{title2}</p> : ''}
      </h1>
      {children}
    </div>
  )
}

export default Subpages
